<template lang="pug">
.curso-main-container.pb-3
  BannerInterno
  .container.tarjeta.tarjeta--blanca.p-4.p-md-5.mb-5
    .titulo-principal.color-acento-contenido(data-aos="flip-up")
      .titulo-principal__numero
        span 3
      h1 Humanización en salud
    
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-4.col-6.mb-4.mb-lg-4
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema3/img1.jpg" alt="Icono 1")
      .col-lg-8.mb-0.mb-lg-0
        .cajon.color-secundario.p-4.mb-4
          p.mb-0(data-aos="fade-left")  En el presente tema se aborda la humanización desde la visión de autores como José Bermejo, Angelo Brusco, Regrado, Herranz y Torras Raventos. Aunque, la humanización es un término que emerge de temas como el ser humano, su entorno, el trato, las relaciones humanas, entre otros aspectos, se puede afirmar que no hay un concepto único, cierto y obvio de humanización; por el contrario, es un concepto polisémico, amplio, sencillo y complejo a la vez, dado que puede incorporar diversos ámbitos o dimensiones del ser humano.
        .row.justify-content-center.p-2
          .col-lg-1.p-0.d-none.d-lg-block
            figure(data-aos="zoom-in")
              img.img-fluid(src="@/assets/curso/temas/tema3/img2.svg" alt="Icono 1")
          .col-lg-11
            p.mb-0(data-aos="fade-left") Esta caracterización debe realizarse a través de medios digitales preferiblemente, antes de iniciar las actividades laborales, recordando siempre conservar consentimiento informado que garantice la confidencialidad de la información.
    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Definiciones
    p.mb-4 De las múltiples definiciones de “humanización” se rescatan las siguientes:
    
    .row.justify-content-center.mb-5
      .col-12.movil.mb-4
        .tarjeta.tarjeta--BG04.p-4
          figure.mb-4
              img(src="@/assets/curso/temas/tema3/img3.jpg", alt="alt")
          h4.mb-3 Bermejo (2014, p. 27)
          p.mb-0 Humanizar corresponde a “hacer humano, familiar, afable a alguien o algo”. “Es ablandarse, desenojarse, hacerse benigno”. Diccionario de María Moliner.
      .col-xl-4.col-lg-7.col-md-9.col-11.mb-4.mb-xl-0.desktop
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(src="@/assets/curso/temas/tema3/img3.jpg", alt="alt")
          .crd_hover_txt--body
            .tit-tarj.p-3
              .ubicar
                .acordion__accion.acordion__accion__btn--b.h3.mb-0
                  i.fas.fa-angle-up
                h4.mb-3 Bermejo (2014, p. 27)
            p.mt-3.px-4 Humanizar corresponde a “hacer humano, familiar, afable a alguien o algo”. “Es ablandarse, desenojarse, hacerse benigno”. Diccionario de María Moliner.
      .col-12.movil.mb-4
        .tarjeta.tarjeta--BG04.p-4
          figure.mb-4
              img(src="@/assets/curso/temas/tema3/img4.jpg", alt="alt")
          h4.mb-3 Bermejo (2014, p. 29)
          p.mb-0 Humanizar ha sustituido a humanar “Hacer una cosa más humana, menos cruel, menos dura para los hombres”. Diccionario de la Lengua Española.

      .col-xl-4.col-lg-7.col-md-9.col-11.mb-4.mb-xl-0.desktop
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(src="@/assets/curso/temas/tema3/img4.jpg", alt="alt")
          .crd_hover_txt--body
            .tit-tarj.p-3
              .ubicar
                .acordion__accion.acordion__accion__btn--b.h3.mb-0
                  i.fas.fa-angle-up
                h4.mb-3 Bermejo (2014, p. 29)
            p.mt-3.px-4 Humanizar ha sustituido a humanar “Hacer una cosa más humana, menos cruel, menos dura para los hombres”. Diccionario de la Lengua Española.
      
      .col-12.movil
        .tarjeta.tarjeta--BG04.p-4
          figure.mb-4
              img(src="@/assets/curso/temas/tema3/img5.jpg", alt="alt")
          h4.mb-3 Gutiérrez (2011, pp. 1-8)
          p.mb-0 “Humanizar es una cuestión ética, con los valores, busca el bien de la persona, impregna las relaciones con valores y actitudes genuinamente humanos”. 

      .col-xl-4.col-lg-7.col-md-9.col-11.mb-4.mb-xl-0.desktop
        .crd_hover_txt(data-aos="flip-left")
          .crd_hover_txt--img
            figure
              img(src="@/assets/curso/temas/tema3/img5.jpg", alt="alt")
          .crd_hover_txt--body
            .tit-tarj.p-3
              .ubicar
                .acordion__accion.acordion__accion__btn--b.h3.mb-0
                  i.fas.fa-angle-up
                h4.mb-3 Gutiérrez (2011, pp. 1-8)
            p.mt-3.px-4 “Humanizar es una cuestión ética, con los valores, busca el bien de la persona, impregna las relaciones con valores y actitudes genuinamente humanos”. 
    .row.justify-content-center.align-items-center.mb-5
      .col-lg-10
        p.mb-0 En cuanto a la definición de la humanización en salud, a continuación, se enuncian los aspectos más relevantes:

    .row.justify-content-center.align-items-center.mb-4
      .col-lg-8.order-2.order-lg-1
        AcordionA.mb-5(tipo="b" clase-tarjeta="tarjeta tarjeta--azul")
          .row(titulo="Monteiro (2008, p. 9)")
            .col-lg-12
              p “Es el acto de humanizar, son las condiciones del hombre, en el sentido de ser humano, se reconoce el grado de corresponsabilidad y presupone un cambio en las personas, en la forma de trabajar, en la estructura y reforma de atención, se relaciona con cambio en la cultura de atención y la gestión”. 
          .row(titulo="De Bello (2000, p. 1)")
            .col-lg-12
              p “Son todas las acciones, medidas y comportamientos que garantizan y salvaguardan la vida y la dignidad de cada ser humano, significa que el usuario está en el centro, el usuario en una organización no es solamente el paciente, sino cada persona que interactúa con el espacio físico y con la organización del establecimiento”. 
          .row(titulo="Martins et al. (2008, pp. 276-281)")
            .col-lg-12
              p “La humanización se visualiza como el conjunto de iniciativas para la producción del cuidado conciliando tecnología con acogimiento, ética y cultura”.
          .row(titulo="Bermejo (2013, pp. 3-12)")
            .col-lg-12
              p “Cuando los valores llevan a diseñar políticas, programas, realizar cuidados y velar por las relaciones asociadas con la dignidad de todo ser humano, se habla de humanización”.
      .col-lg-4.col-8.order-1.order-lg-2
        figure
          img.img-fluid(src="@/assets/curso/temas/tema3/img6.png" alt="Imagen decorativa")

    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Características
    p.mb-4 Las características necesarias para abordar la humanización son tan diversas y variadas como lo son las del ser humano. Sin embargo, a continuación, se rescatan algunas cualidades necesarias para entender la humanización desde acciones cotidianas y para humanizar el sistema de salud, basadas en los diferentes expertos en el área:
    
    AcordionA(tipo="a" clase-tarjeta="tarjeta tarjeta--azul mb-4")
      .row(titulo="Monteiro (2008, p. 9)")
        .col-lg-8.order-2.order-lg-1
          p La humanización distingue las condiciones y el sentido del ser humano de forma integral con el entorno, se impregna de valores y actitudes genuinamente humanos.

        .col-lg-4.col-12.mb-4.mb-lg-4.order-1.order-lg-2
          figure(data-aos="zoom-in")
            img.img-fluid(src="@/assets/curso/temas/tema3/img7.jpg" alt="Icono 1")
      .row(titulo="Bermejo (2013, pp. 3-12)")
        .col-lg-8.order-2.order-lg-1
          ul.lista-ul.mb-0
            li(data-aos="fade-right") 
              i.lista-ul__vineta
              | Distingue al ser humano en su individualidad y colectividad.
            li(data-aos="fade-right") 
              i.lista-ul__vineta
              | Establece un compromiso ético para el goce efectivo del derecho, en proteger la vida y en reconocer la dignidad de todo ser humano con sus dificultades e inclusión en la vida social.

        .col-lg-4.col-12.mb-4.mb-lg-4.order-1.order-lg-2
          figure(data-aos="zoom-in")
            img.img-fluid(src="@/assets/curso/temas/tema3/img8.jpg" alt="Icono 1")
      .row(titulo="Confederación Médica Latinoamericana y del Caribe & Organización Médica Colegial de España (2016, p. 18)")
        .col-lg-8.order-2.order-lg-1
          p Se fundamenta en la relación interpersonal que conlleva a la personalización, al respeto, al amor, al altruismo, compasión, a la empatía, a la calidez.

        .col-lg-4.col-12.mb-4.mb-lg-4.order-1.order-lg-2
          figure(data-aos="zoom-in")
            img.img-fluid(src="@/assets/curso/temas/tema3/img9.jpg" alt="Icono 1")
      .row(titulo="Raventós (1985, p. 12)")
        .col-lg-8.order-2.order-lg-1          
          ul.lista-ul.mb-0
            li(data-aos="fade-right") 
              i.lista-ul__vineta
              | Un sistema sanitario humanizado es aquél cuya razón de ser, es estar al servicio de la persona y, por tanto, está pensado y concebido en función del hombre.
            li(data-aos="fade-right") 
              i.lista-ul__vineta
              | La humanización tiene que ver con la gestión, la concepción del sistema sanitario, el funcionamiento de las estructuras sanitarias, la mentalidad de las personas involucradas en la misma, la competencia profesional y elementos no fácilmente comunicables como el dolor evitado, el sufrimiento prevenido, las capacidades recuperadas, y la alegría recobrada.
            li(data-aos="fade-right") 
              i.lista-ul__vineta
              | Los procesos de humanización tienen que ver con las actitudes.
            li(data-aos="fade-right") 
              i.lista-ul__vineta
              | Es necesario que los hospitales sean más humanos, exista un mayor respeto a la dignidad humana; por lo tanto, se requiere formación del personal de salud, en cuanto a la organización de los servicios para la atención, información al ser humano, sujeto de cuidado sobre su enfermedad y tratamiento específico; así como, preparación psicológicamente a la muerte.

        .col-lg-4.col-12.mb-4.mb-lg-4.order-1.order-lg-2
          figure(data-aos="zoom-in")
            img.img-fluid(src="@/assets/curso/temas/tema3/img10.jpg" alt="Icono 1")

    .titulo.mt-4.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Ejemplos
    p.mb-4 Los ejemplos de humanización se evidencian en acciones cotidianas en las que se reconoce al ser humano de manera integral, tal como se ha señalado anteriormente. De igual forma, la humanización en salud se manifiesta en diversas situaciones, áreas y departamentos, siendo esto posible gracias a la participación de múltiples actores que hacen efectiva su aplicación en la práctica.
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-5.col-10.mb-4.mb-lg-4
          figure(data-aos="zoom-in")
            img.img-fluid(src="@/assets/curso/temas/tema3/img11.jpg" alt="Icono 1")
      .col-lg-5
        p Basado en lo anterior, se relacionan los siguientes ejemplos:
        
        a.anexo.mb-4.mb(href="https://www.youtube.com/watch?v=a89e3tbZErU" target="_blank")
          .anexo__icono
            img(src="@/assets/template/icono-link.svg")
          .anexo__texto
            p Ejemplo 1. Las batas más fuertes. Hospital San Rafael
        
        a.anexo.mb-4(href="https://www.youtube.com/watch?v=bl5zrIXoK9Q#action=share U" target="_blank")
          .anexo__icono
            img(src="@/assets/template/icono-link.svg")
          .anexo__texto
            p Ejemplo 2. Salud universal en las américas. OPS
        
        a.anexo.mb-4.mb-lg-0(href="https://www.youtube.com/watch?v=6NpxbFm6eTY" target="_blank")
          .anexo__icono
            img(src="@/assets/template/icono-link.svg")
          .anexo__texto
            p Ejemplo 3. Estación Lunar Juegaterapia. Hospital Gregorio Marañón
    .row.justify-content-center.align-items-center
      .col-lg-10
        .titulo.mb-4(data-aos="fade-left")
          img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
          h5 No son ejemplos

    .BMG1.p-4
      .row.justify-content-center.align-items-center
        .col-lg-10
          p A continuación, se describen aspectos y prácticas que no corresponden a la humanización en salud, ya que priorizan intereses particulares, procesos administrativos, financieros o tecnológicos por encima del bienestar, la participación y el trato digno de las personas, debilitando los vínculos, la confianza y la atención centrada en el ser humano:
      .row.justify-content-center.align-items-center
        .col-lg-10
          ol.lista-ol--cuadro
            li
              .lista-ol--cuadro__vineta
                span 1
              | Prevalencia del bien particular.
            li
              .lista-ol--cuadro__vineta
                span 2
              | Despersonalización, entendida como una situación en ausencia de relaciones interpersonales.
            li
              .lista-ol--cuadro__vineta
                span 3
              | Prevalencia del proceso administrativo sobre la persona.
            li
              .lista-ol--cuadro__vineta
                span 4
              | Falta de confianza entre las personas de apropiación institucional, fragmentación y desarticulación entre agentes.
            li
              .lista-ol--cuadro__vineta
                span 5
              | Condiciones laborales inadecuadas del personal de salud.
            li
              .lista-ol--cuadro__vineta
                span 6
              | Dificultad en la participación de las personas en su manejo terapéutico.
            li
              .lista-ol--cuadro__vineta
                span 7
              | El uso inapropiado de la tecnología puede empobrecer la relación interpersonal.
            li
              .lista-ol--cuadro__vineta
                span 8
              | Deficiencias en el entorno e infraestructura, relacionadas con confort, calidez e intimidad de la persona.
            li
              .lista-ol--cuadro__vineta
                span 9
              | La administración organizacional se limita en diversos casos a los intereses políticos, dejando de lado las necesidades de las personas.
            li
              .lista-ol--cuadro__vineta
                span 10
              | La gestión en salud está orientada a cumplir procesos relacionados con aspectos financieros y no centrada en la salud de la persona.
            li
              .lista-ol--cuadro__vineta
                span 11
              | Los servicios de salud están reducidos al utilitarismo y a las reglas del mercado.
    .titulo.mb-4(data-aos="fade-left")
      img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
      h5 Componentes
    p.mb-4 Debido a las múltiples maneras de entender y abordar la humanización, es difícil establecer un procedimiento o paso a paso para desarrollarla. No obstante, se pueden reconocer diversas acciones básicas para practicar la humanización, en este caso, aquellas acciones que favorezcan la atención en salud. A continuación, se presentan algunos de los componentes esenciales de la humanización en salud:

    .BMG3.p-4
      .row.justify-content-center.align-items-center
        .col-lg-10
          ul.lista-ul
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Humanizarse primero para humanizar a los demás.              
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Abordar la humanización desde un trabajo en equipo y multidisciplinario.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 La automotivación y motivación a otros, para que practiquen y fomenten relaciones interpersonales humanizadas.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 El compromiso de la organización con la cultura de humanización.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 El alto grado de corresponsabilidad por parte del personal de salud.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 El abordaje de forma integral del ser humano.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 La generación de lineamientos que mejoren la gestión en salud y condiciones laborales.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 La formación continua al personal de salud en capacidades, habilidades, ética, empatía, sentido en el trabajo, entre otras.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 La conciliación de la tecnología con acogimiento, personalización ética y cultura.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 La promoción de una cultura donde prevalezcan los valores humanos auténticos.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Prioriza el crecimiento personal, rescata lo genuino basado en el bienestar propio y del bien común.
            li
              i.fas.fa-briefcase-medical
              p.mb-0 Conecta las relaciones de la organización (personal de salud - persona y red de apoyo, persona y red de apoyo - personal de salud, personal de salud – persona y red de apoyo – directivas).
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10
        .cajon.color-primario.p-4.mb-4
          .row.justify-content-center.align-items-center
            .col-lg-2.d-none.d-lg-block
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img12.svg" alt="Icono 1")

            .col-lg-10
              p.mb-0 Nota: los anteriores componentes relacionados sobre la humanización en salud, son basados en las intervenciones de los autores: Bermejo y Durbán (2013), Hoyos, Cardona y Correa (2008), Monteiro (2008).
    
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10
        .titulo.mb-4(data-aos="fade-left")
          img(src='@/assets/curso/icon.svg', alt='Imagen decorativa')
          h5 Enfoques
    
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-10
        p.mb-0 Cada persona e institución desde lo individual o colectivo, puede desarrollar el abordaje conceptual de la humanización de la atención, dando prelación a aquellas características que considera más relevantes. Para ello, se puede abordar la humanización desde uno o varios enfoques. En el sector salud, como base, se presentan los siguientes:
    
    .tarjeta--BMG4.p-5
      .tarjeta.tarjeta--gris.p-4
        PasosB.color-acento-contenido
          .row(titulo="")
            .col-lg-6.mb-4.mb-md-0.order-2.order-lg-1
              h5  Enfoque derechos humanos
              p.mb-0 Se caracteriza en reconocer que todos los seres humanos nacen libres e iguales en dignidad y derechos. Asimismo, reconoce la libertad, la dignidad y el derecho otorgado de razón, conciencia y comportamiento fraterno individual y colectivo.
            .col-lg-6.col-10.order-1.order-lg-2.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img13.jpg" alt="Imagen decorativa")
          .row(titulo="")
            .col-lg-6.mb-4.mb-md-0.order-2.order-lg-1
              h5  Enfoque ecosistémico
              p.mb-0 Permite una lectura más integral y holística, ya que genera un conocimiento integral entre aspectos como: el entorno, lo biológico, lo físico, cultural, económico, político y social, con relación a la problemática identificada en salud; lo cual, aborda el pensamiento complejo, del trabajo transdisciplinario e intersectorial, de la participación sistémica y comunitaria; se reconoce las particularidades y las generalidades, la sostenibilidad con la generación de alternativas por la sociedad afectada, la equidad social y el fomento de procesos de investigación.
            .col-lg-6.col-10.order-1.order-lg-2.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img14.jpg" alt="Imagen decorativa")
          .row(titulo="")
            .col-lg-6.mb-4.mb-md-0.order-2.order-lg-1
              h5  Enfoque ética y bioética
              p Tiene como fundamento los principios y valores irrenunciables, que trascienda la mercantilización de la salud y favorezca la humanización en salud; de igual manera, la bioética tiene que ver con la protección de la vida.
              p.mb-0 Considera al ser humano como ser social, en donde encuentra su propio bien, capaz de razonar, conocer, nombrar, distinguir, jerarquizar, reconocer lo justo de lo injusto, establecer leyes y la búsqueda del bienestar.
            .col-lg-6.col-10.order-1.order-lg-2.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img15.jpg" alt="Imagen decorativa")
          .row(titulo="")
            .col-lg-6.mb-4.mb-md-0.order-2.order-lg-1
              h5  Enfoque humanístico
              p.mb-0 Comprende al ser humano desde una visión multidimensional que promueve el acto de reconocimiento del sujeto como sujeto, más allá de sus propios condicionantes o estímulos externos, incluso más allá de lo que él mismo considera como sus propias posibilidades, pero que es capaz de orientarse a un propósito y por tanto, otorgarse el derecho de asignarle un significado a la vida, sin lugar a duda situado en una circunstancia, un entorno, un territorio existencial, capaz de trascenderse a sí mismo y orientar su vida.
            .col-lg-6.col-10.order-1.order-lg-2.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img16.jpg" alt="Imagen decorativa")
          .row(titulo="")
            .col-lg-6.mb-4.mb-md-0.order-2.order-lg-1
              h5  Enfoque diferencial
              p.mb-0 Considera la inclusión de las personas, diferencias y semejanzas con el otro, reconoce la diversidad etaria, étnica, cultural, de discapacidad y situaciones especiales de vulneración de derechos (desplazamiento, condición legal, ubicación geográfica, violencia).
            .col-lg-6.col-10.order-1.order-lg-2.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img17.jpg" alt="Imagen decorativa")
          .row(titulo="")
            .col-lg-6.mb-4.mb-md-0.order-2.order-lg-1
              h5  Enfoque poblacional
              p.mb-0 Reconoce la relación que hay entre la población con el territorio y las condiciones propias que posee cada población, en aspectos políticos, socioeconómicos, religiosos, culturales y ambientales, así como, en su dinámica demográfica, para abordar y dar solución a las problemáticas.
            .col-lg-6.col-10.order-1.order-lg-2.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img18.jpg" alt="Imagen decorativa")
          .row(titulo="")
            .col-lg-6.mb-4.mb-md-0.order-2.order-lg-1
              h5  Enfoque intercultural
              p.mb-0 Parte del respeto por las diferencias culturales existentes en el territorio nacional, a partir del reconocimiento de los saberes, prácticas y medios tradicionales, alternativos y complementarios para la recuperación de la salud.
            .col-lg-6.col-10.order-1.order-lg-2.mb-4.mb-lg-0
              figure(data-aos="zoom-in")
                img.img-fluid(src="@/assets/curso/temas/tema3/img19.jpg" alt="Imagen decorativa")

          
    separador
    #t_3_1.titulo-segundo.color-acento-contenido(data-aos="fade-left")
      h2  3.1	Conceptualización humanización en salud

    p.mb-4 Es momento de integrar la información presentada y aportar una reflexión personal que permita construir un concepto propio de humanización en salud. Para ello, se debe realizar lo siguiente:
    .row.justify-content-center.align-items-center.mb-4
      .col-lg-2.d-lg-block.d-none
        figure(data-aos="zoom-in")
          img.img-fluid(src="@/assets/curso/temas/tema3/img20.svg" alt="Imagen decorativa")
      .col-lg-10
        ol.lista-ol--cuadro
          li
            .lista-ol--cuadro__vineta
              span 1
            | Acceder y analizar el video relacionado.
          li
            .lista-ol--cuadro__vineta
              span 2
            | Durante el video se realizarán pausas para responder preguntas orientadoras. Se sugiere escribir las respuestas de acuerdo con el sentir y el pensar personal; no existen respuestas correctas o incorrectas, ya que se trata de una construcción individual. Posteriormente, es importante guardar las respuestas en un documento en el computador.
          li
            .lista-ol--cuadro__vineta
              span 3
            | Al finalizar el video, redactar los conceptos construidos y guardarlos para repasar y reflexionar sobre las apreciaciones personales.
    .row.justify-content-center.align-items-center
      .col-lg-12
        figure(data-aos="zoom-in")
          .video
            iframe(width="1401" height="788" src="https://www.youtube.com/embed/H_ReAjWUp_E" title="Contextualización ser humano y humanización en salud" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen)

</template>

<script>
export default {
  name: 'Tema3',
  data: () => ({
    // variables de vue
  }),
  mounted() {
    this.$nextTick(() => {
      this.$aosRefresh()
    })
  },
  updated() {
    this.$aosRefresh()
  },
}
</script>

<style lang="sass"></style>
